import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../common/Navbar';
import Footer from '../common/Footer';
import useScrollToTop from '../../hooks/useScrollToTop';

const MainLayout: React.FC = () => {
  useScrollToTop();
  const { pathname } = useLocation();
  const isHomePage = pathname === '/';

  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden">
      <Navbar />
      <main className={`flex-grow ${isHomePage ? '' : 'pt-16 sm:pt-[4.5rem]'}`}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout; 